/**
 * Tab Component
 *
 * @file tab.js
 */
import $ from "jquery";
const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const calculateTab = () => {
    // Tüm tab item'ları seç
    window.onload = function() {
      var loadingDivs = document.querySelectorAll('.calculate-loading');
      loadingDivs.forEach(function(div) {
        div.remove();
      });
    };
    const tabItems = document.querySelectorAll('.calculate-tab-item');

    // Her tab item'a click event listener ekle
    tabItems.forEach(tabItem => {
      tabItem.addEventListener('click', () => {
        // İlgili tab container'ı bul
        const tabContainer = tabItem.closest('.calculate-tab');

        // Tüm tab item'ları ve içerikleri tab container içinde ara
        const containerTabItems = tabContainer.querySelectorAll('.calculate-tab-item');
        const containerTabContents = tabContainer.querySelectorAll('.calculate-tab-content');

        // Tıklanan tab item'ı bul
        const clickedIndex = Array.from(containerTabItems).indexOf(tabItem);

        // Tüm tab item'lardan active class'ı kaldır
        containerTabItems.forEach(item => {
          item.classList.remove('tab-active');
        });
        // Tıklanan tab item'a active class'ı ekle
        tabItem.classList.add('tab-active');

        // Tüm tab içeriklerini gizle
        containerTabContents.forEach(content => {
          content.classList.remove('tab-content-active');
        });
        // Tıklanan tab item'a karşılık gelen tab içeriğini göster
        containerTabContents[clickedIndex].classList.add('tab-content-active');
      });
    });
  };
  const calculateTabInTab = () => {
    // Tüm tab item'ları seç
    $(".calculate-tab-in-tab .item").on("click", function(){
      $(this).parents(".calculate-content").find(".calculate-tab-in-tab .item").removeClass("tab-active");
      $(this).addClass("tab-active");
      $(this).parents(".calculate-content").find(".calculate-tab-in-tab-content").removeClass("tab-active");
      $(this).parents(".calculate-content").find(".calculate-tab-in-tab-content").eq($(this).index()).addClass("tab-active");
    });
  };

  const cookieTab = () => {
    // Tüm tab item'ları seç
    $(".cookie-modal-tab .modal-tab-item").on("click", function(){
      $(".cookie-modal-tab .modal-tab-item").removeClass("active");
      $(this).addClass("active");
      $(".modal-tab-content").removeClass("tab-active");
      $(".modal-tab-content").eq($(this).index()).addClass("tab-active");
    });
  };

  const boardTab = () => {
    document.addEventListener("DOMContentLoaded", function() {
      var tabItems = document.querySelectorAll(".board-member-tab .item");
      var tabContents = document.querySelectorAll(".board-member-tab-content");
  
      tabItems.forEach(function(item, index) {
          item.addEventListener("click", function() {
              tabItems.forEach(function(tabItem) {
                  tabItem.classList.remove("active");
              });
              this.classList.add("active");
  
              tabContents.forEach(function(tabContent) {
                  tabContent.classList.remove("tab-active");
              });
              tabContents[index].classList.add("tab-active");
          });
      });
    });

    $("#cookie-all-cancel").on("click", function(){
      $(".footer-cookie-policy").remove();
    });

    $(".mobile-filter-toggle").on("click", function(){
      $("body").addClass("hide-scrollbar");
      $(".left-filter").show();
    });
    $(".filter-close").on("click", function(){
      $("body").removeClass("hide-scrollbar");
      $(".left-filter").hide();
    });
  };


  const init = () => {
    calculateTab();
    calculateTabInTab();
    cookieTab();
    boardTab();
  };

  return {
    init,
  };
})();

export default tabs;
